var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes()},[_c('ul',{class:`${_vm.el}__list`},_vm._l((_vm.items),function(item){return _c('li',{key:item.text,class:`${_vm.el}__listItem`},[_c('Link',{class:`${_vm.el}__link`,attrs:{"to":item.link,"external":item.external,"weight":"regular","no-underline":""}},[_vm._v(" "+_vm._s(item.text)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }